import { checkout as checkoutApi } from '@consumer/api'
import { isEmail } from '@shared/regex'
import type { InputValidation } from '@shared/validation'
import { isValidPhoneNumber as isValidPhoneNumberLib } from 'libphonenumber-js'

export async function isValidEmail (email: string, options?: { skipMailgun?: boolean }): Promise<boolean> {
  const isValid = isEmail(email)

  if (options?.skipMailgun || !isValid) return isValid

  try {
    return await checkoutApi.validateEmail({ data: { email } }).then(({ result }) => result)
  }
  catch {
    return isValid
  }
}

export function isUsPhone (number?: string) {
  if (!number) return false
  return isValidPhoneNumberLib(number, 'US')
}

//
// Validations compatible with GForm and GInput.
// Validates phone numbers for all countries using libphonenumber-js.
//
export const isValidPhoneNumber: InputValidation = {
  isValueValid: (value) => {
    if (!value)
      return true

    if (typeof value === 'string') {
      return isUsPhone(value)
    }

    if (typeof value === 'object') {
      // Allow empty phone numbers (cleared/reset)
      if (!value.number || value.number.replace(/\D/g, '').length === 0)
        return true

      // Validate using libphonenumber-js with the country code
      return isValidPhoneNumberLib(`+${value.countryDialingCode}${value.number}`)
    }

    return false
  },
  errorMessage: () => 'Please enter a valid phone number',
}

//
// Validations compatible with GForm and GInput.
//
export const isValidUsPhoneNumber: InputValidation = {
  isValueValid: value => !value || isUsPhone(value),
  errorMessage: () => 'Please enter a valid US phone number',
}

function doesNotContainUnicodeChars (text?: string) {
  const regex = /[\u4E00-\u9FFF\u3000-\u303F\u3040-\u30FF\u31F0-\u31FF\uAC00-\uD7AF]/

  return !regex.test(String(text))
}

//
// Validations compatible with GForm and GInput.
//
export const noUnicode: InputValidation = {
  isValueValid: value => !value || doesNotContainUnicodeChars(value),
  errorMessage: () => 'Contains unsupported characters. Please remove and try again.',
}
